import { faAngleRight as lightAngleRight } from "@jewlr/pro-light-svg-icons/faAngleRight"
import {
  Box,
  Divider,
  FontAwesomeIcon,
  Flex,
  Typography,
} from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import {
  Paragraph,
  Section,
  SectionLeft,
  SectionRight,
  SectionTitle,
} from "./components"
import MainBanner from "./main-banner"

const PressSubtitle = styled(SectionTitle)`
  font-weight: normal;
  letter-spacing: 1.25px;
  line-height: 1.5;
  text-align: left;
  text-transform: capitalize;
`

const PressInfo = styled(Flex)`
  background-color: ${(props) => props.theme.colors.polar};
  padding: 1.5em 0;
  ${(props) => props.theme.mediaQueries.tablet`
    margin: 2em 0 3em;
    padding: 2.5em 0;
  `};
`
const PressInfoItem = styled(Box)`
  border-right: 1px solid ${(props) => props.theme.colors.grey10};
  text-align: center;
  width: 50%;
  &:last-child {
    border-right: none;
  }
`
const PressInfoTitle = styled(Typography)`
  font-size: 16px;
  font-weight: normal;
  line-height: 1.1;
  margin: 0 0 0.2em;
  text-align: center;
  text-transform: uppercase;

  ${(props) => props.theme.mediaQueries.tablet`
    margin: 0 0 0.5em;
    font-size: 18px;
  `};
`
const Press = () => (
  <>
    <MainBanner alt="Press" src="press" />
    <Box contain px={{ _: "10px", tablet: 2 }}>
      <Section>
        <SectionLeft>
          <SectionTitle>Jewlr In The News</SectionTitle>
        </SectionLeft>
        <SectionRight>
          <PressSubtitle textAlign="left">
            Jewlr Named Pure Play Of The Year Award (Large) At The 2018 Canada
            Post E-Commerce Innovation Awards
          </PressSubtitle>

          <Paragraph>
            <strong>TORONTO, ONTARIO-- PRWeb - Sept. 28, 2018</strong> - At a
            recent gala held at The Fairmont Royal York Hotel in Toronto, Jewlr
            took home top honours in the 2018 Canada Post E-commerce Innovation
            Awards. Recognized by the judging panel for its innovative business
            model in delivering personalized jewelry and for providing a
            superior online customer experience, Jewlr was named Pure Play of
            the Year Award (Large). The category is focused completely on the
            e-commerce channel, and pays tribute to the online shopping
            experience that is most engaging and effective. Jewlr will receive
            $100,000 in free shipping as well as valuable marketing prize
            packages.
          </Paragraph>

          <Typography
            as={Link}
            color="primary"
            data-lc="press"
            fontSize="14px"
            fontWeight="300"
            to={"/info/press/jewlr_wins_2018_pure_play_awards"}
          >
            READ MORE <FontAwesomeIcon icon={lightAngleRight} />
          </Typography>

          <Divider color={"#ebebec"} my={3} />
          <PressSubtitle textAlign="left">
            Sketchfab Disrupts Traditional Banner Advertising
          </PressSubtitle>

          <Paragraph>
            <strong>PRWEB - May. 11, 2017</strong> - JEWLR, a progressive
            jewelry e-commerce shop, is using Sketchfab, the world’s largest
            platform to publish, share and discover 3D content online to disrupt
            the world of traditional banner advertisements.{" "}
          </Paragraph>

          <Typography
            as={Link}
            color="primary"
            data-lc="press"
            fontSize="14px"
            fontWeight="300"
            to={"/info/press/sketchfab_disrupts_tranditional_adv"}
          >
            READ MORE <FontAwesomeIcon icon={lightAngleRight} />
          </Typography>

          <Divider color={"#ebebec"} my={3} />
          <PressSubtitle textAlign="left">
            Tony Davis Praises Online Retailer Jewlr.com&apos;s Personal Touch
          </PressSubtitle>

          <Paragraph>
            <strong>PRWEB - May. 11, 2017</strong> - JEWLR, a progressive
            jewelry e-commerce shop, is using Sketchfab, the world’s largest
            platform to publish, share and discover 3D content online to disrupt
            the world of traditional banner advertisements.{" "}
          </Paragraph>

          <Typography
            as={Link}
            color="primary"
            data-lc="press"
            fontSize="14px"
            fontWeight="300"
            to={"/info/press/tony_davis_praises_jewlr_personal_touch"}
          >
            READ MORE <FontAwesomeIcon icon={lightAngleRight} />
          </Typography>

          <Divider color={"#ebebec"} my={3} />
          <PressSubtitle textAlign="left">
            Online jeweller business has a disruptive ring
          </PressSubtitle>

          <Paragraph>
            <strong>Toronto Star - Dec. 9, 2013</strong> - Tony Davis confesses
            he didn’t know a thing about jewelry when he decided to launch on an
            online website to sell personalized designs
          </Paragraph>
          <Typography
            as={Link}
            color="primary"
            data-lc="press"
            fontSize="14px"
            fontWeight="300"
            to={"/info/press/online_jeweller_has_a_disruptive_ring"}
          >
            READ MORE <FontAwesomeIcon icon={lightAngleRight} />
          </Typography>

          <Divider color={"#ebebec"} my={3} />
          <PressSubtitle textAlign="left">
            Jewlr Named Most Innovative Retailer in 2013 Canada Post E-Commerce
            Innovation Awards
          </PressSubtitle>

          <Paragraph>
            <strong>
              THORNHILL, ONTARIO--(Marketwired - Sept. 26, 2013) -
            </strong>{" "}
            At a gala held last night at the Metro Toronto Convention Centre,{" "}
            <Typography
              as={Link}
              color="primary"
              data-lc="press"
              fontSize="14px"
              fontWeight="300"
              to="/"
            >
              Jewlr
            </Typography>{" "}
            took home top honours in the{" "}
            <Typography
              as="a"
              color="primary"
              fontSize="14px"
              fontWeight="300"
              href="https://canadapost.ca/ecommerceawards"
            >
              2013 Canada Post E-commerce Innovation Awards
            </Typography>
            . Recognized by the judging panel for its innovative business model
            in delivering personalized jewelry and for providing a superior
            online customer experience, Jewlr was named the{" "}
            <em>Most Innovative (Large) Retailer</em>. Jewlr will share a $1
            million total prize package - which includes shipping services and
            customized direct marketing packages - with seven other retailers
            that were recognized in their specific categories.
          </Paragraph>
          <Typography
            as={Link}
            color="primary"
            data-lc="press"
            fontSize="14px"
            fontWeight="300"
            to={"/info/press/jewlr_named_innovative_retailer_in_2013"}
          >
            READ MORE <FontAwesomeIcon icon={lightAngleRight} />
          </Typography>
        </SectionRight>
      </Section>
      <Divider color="#ebebec" my={3} />
      <Section>
        <SectionLeft>
          <SectionTitle>Jewlr In The Press</SectionTitle>
        </SectionLeft>
        <Box>
          <Box>
            <Typography
              as="a"
              color="primary"
              fontSize="14px"
              fontWeight="300"
              href="http://www.genuinejenn.com/2012/11/jewlrcom-review-black-friday-sale.html"
              rel="nofollow noopener"
              target="_blank"
            >
              Genuine Jenn
            </Typography>
            <Paragraph mb={0}> </Paragraph>

            <Typography
              as="a"
              color="primary"
              fontSize="14px"
              fontWeight="300"
              href="http://www.momsownwords.com/reviews-and-shopping/jewlr-infinity-ring-giveaway-rv-130-and-3-stone-ring-review/"
              rel="nofollow noopener"
              target="_blank"
            >
              Mom&apos;s Own Words
            </Typography>
            <Paragraph mb={0}> </Paragraph>
            <Typography
              as="a"
              color="primary"
              fontSize="14px"
              fontWeight="300"
              href="http://www.atthefenceonline.com/2012/11/jewlr-has-gift-ideas.html"
              rel="nofollow noopener"
              target="_blank"
            >
              At The Fence
            </Typography>
            <Paragraph mb={0}> </Paragraph>
          </Box>
        </Box>
        <Box>
          {" "}
          <Typography
            as="a"
            color="primary"
            fontSize="14px"
            fontWeight="300"
            href="http://www.coupondad.net/jewlr-com-review/"
            rel="nofollow noopener"
            target="_blank"
          >
            Coupon Dad
          </Typography>
          <Paragraph mb={0}> </Paragraph>
          <Typography
            as="a"
            color="primary"
            fontSize="14px"
            fontWeight="300"
            href="http://www.parenting.com/"
            rel="nofollow noopener"
            target="_blank"
          >
            Parenting Magazine
          </Typography>
        </Box>
      </Section>
      <PressInfo>
        <PressInfoItem>
          <PressInfoTitle>Media Inquries</PressInfoTitle>
          <Typography
            as="a"
            color="primary"
            display="inline-block"
            href="mailto:press@jewlr.com"
          >
            press@jewlr.com
          </Typography>
        </PressInfoItem>
        <PressInfoItem>
          <PressInfoTitle>Logo</PressInfoTitle>
          <Typography
            as="a"
            color="primary"
            display="inline-block"
            href={`${sl.config.jewlr_asset_url}images/logos/jewlr_logo.eps`}
          >
            Download
          </Typography>
        </PressInfoItem>
      </PressInfo>
    </Box>
  </>
)

export default Press
